export const question1 = 'Would you prefer a call or a visit?';
export const question2 =
  'Please describe how your coach can support you during this visit';
export const callType = 'call';
